export const AUDIT_LOG_TABLE_COLUMNS = [
  { key: 'id', fields: ['id'] },
  { key: 'status', fields: ['status'] },
  { key: 'action', fields: ['action'] },
  { key: 'sku', fields: ['sku', 'uid'] },
  { key: 'side', fields: ['side', 'sequence'], formatSide: true },
  {
    key: 'originalMediaUrl',
    fields: [
      'originalMediaUrl',
      'original_media_url',
      'originalImageUrl',
      'original_image_url',
    ],
    isLink: true,
  },
  { key: 'userId', fields: ['createdBy', 'created_by'] },
  {
    key: 'createdAt',
    fields: ['createdAt', 'created_at'],
    formatDateTime: true,
  },
]

export function pickAuditLogField(item = {}, fields = []) {
  for (const field of fields) {
    const value = item[field]
    if (value !== undefined && value !== null && value !== '') {
      return value
    }
  }

  return ''
}

export function normalizeMediaAuditLogItem(item = {}) {
  return AUDIT_LOG_TABLE_COLUMNS.reduce((normalized, column) => {
    normalized[column.key] = pickAuditLogField(item, column.fields)
    return normalized
  }, {})
}
